import * as THREE from 'three';
import { events } from '../core/events.js';

// Short-lived visual flourishes driven by character events. Currently:
// a small dust puff at the feet when the character jumps or lands.

const DUST_GEO = new THREE.SphereGeometry(0.06, 6, 5);
const DUST_LIFE = 0.55;

const _dust = [];
const _t1 = new THREE.Vector3();
const _t2 = new THREE.Vector3();

function spawnDustPuff(scene, center, up, count, energy = 1) {
  // Build a tangent basis at the landing point so velocities stay on-surface.
  const upN = up.clone().normalize();
  const seed = Math.abs(upN.y) > 0.9
    ? new THREE.Vector3(1, 0, 0)
    : new THREE.Vector3(0, 1, 0);
  _t1.crossVectors(upN, seed).normalize();
  _t2.crossVectors(upN, _t1).normalize();

  for (let i = 0; i < count; i++) {
    const angle = (i / count) * Math.PI * 2 + Math.random() * 0.4;
    const mat = new THREE.MeshBasicMaterial({
      color: 0xdadfe6,
      transparent: true,
      opacity: 0.55,
      depthWrite: false,
      fog: false,
    });
    const mesh = new THREE.Mesh(DUST_GEO, mat);
    mesh.position.copy(center).addScaledVector(upN, 0.04);

    // Velocity: mostly outward tangent, a bit upward, randomised per particle.
    const outSpeed = (0.9 + Math.random() * 0.5) * energy;
    const upSpeed  = (0.3 + Math.random() * 0.25) * energy;
    const vel = new THREE.Vector3()
      .addScaledVector(_t1, Math.cos(angle) * outSpeed)
      .addScaledVector(_t2, Math.sin(angle) * outSpeed)
      .addScaledVector(upN, upSpeed);

    scene.add(mesh);
    _dust.push({ mesh, vel, age: 0 });
  }
}

export function initEffects(scene) {
  events.on('character:jumped', ({ position, up }) => {
    spawnDustPuff(scene, position, up, 5, 1.0);
  });
  events.on('character:landed', ({ position, up }) => {
    spawnDustPuff(scene, position, up, 7, 1.3);
  });
}

export function updateEffects(dt) {
  for (let i = _dust.length - 1; i >= 0; i--) {
    const p = _dust[i];
    p.age += dt;
    const t = p.age / DUST_LIFE;
    if (t >= 1) {
      p.mesh.parent?.remove(p.mesh);
      p.mesh.material.dispose();
      _dust.splice(i, 1);
      continue;
    }
    // Drift along velocity, friction, gentle expansion, fade out.
    p.mesh.position.addScaledVector(p.vel, dt);
    p.vel.multiplyScalar(Math.exp(-dt * 2.5));
    p.mesh.scale.setScalar(1 + t * 0.8);
    p.mesh.material.opacity = 0.55 * (1 - t) * (1 - t);
  }
}
